export function compareArrays(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}

export default compareArrays;
